import React from 'react';

interface Person {
  firstName: string;
  lastName: string;
  relationship?: string;
  email?: string;
}

interface PersonInfoDisplayProps {
  person: Person | null;
}

export function PersonInfoDisplay({ person }: PersonInfoDisplayProps) {
  if (!person) {
    return null;
  }

  return (
    <div className="person-info-display">
      <div className="person-info-header">
        <span className="material-symbols-outlined">account_circle</span>
        <span className="person-info-name">
          {`${person.firstName} ${person.lastName}`}
        </span>
      </div>
      <div>
        <div className="person-info-details">
          <div className="person-info-detail">
            <strong>Relationship:</strong> {person.relationship ?? 'not specified'}
          </div>
          <div className="person-info-detail">
            <strong>Email:</strong> {person.email ?? 'not specified'}
          </div>
        </div>
      </div>
    </div>
  );
}
